let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lf96V")).then(() => parcelRequire('5XVuz'));